import { Stack, SelectChangeEvent } from '@mui/material';
import { useCallback } from 'react';
import FilterSingleSelect from 'src/components/filter-form/filter-single-select';
import { UserFilters, UserFilterKey, UserFilterValue } from 'src/type/user';
import UserSearchAutocomplete, { UserOption } from 'src/components/ui-kit/user-search-autocomplete';
import { levelOptions, verificationStatusOption } from './utils';

type Props = {
  filters: UserFilters;
  onFilters: (name: UserFilterKey, value: UserFilterValue) => void;
  disabledSearch?: boolean;
};

export default function UserTableToolbar({ filters, onFilters, disabledSearch }: Props) {
  const handleFilterName = useCallback(
    (user: UserOption | null) => {
      onFilters('name', user);
    },
    [onFilters]
  );

  const handleFilterLevel = useCallback(
    (event: SelectChangeEvent<string>) => {
      onFilters('level', event.target.value);
    },
    [onFilters]
  );

  const handleFilterVerification = useCallback(
    (event: SelectChangeEvent<string>) => {
      onFilters('verification', event.target.value);
    },
    [onFilters]
  );

  return (
    <Stack
      spacing={2}
      alignItems="center"
      direction={{
        xs: 'column',
        md: 'row',
      }}
      sx={{
        p: 2.5,
        width: 1,
      }}
    >
      <FilterSingleSelect
        label="ระดับ"
        sx={{ width: { xs: 1, md: 180 } }}
        value={filters.level}
        onChange={handleFilterLevel}
        options={levelOptions}
      />

      <FilterSingleSelect
        label="การยืนยันตัวตน"
        sx={{ width: { xs: 1, md: 180 } }}
        value={filters.verification}
        onChange={handleFilterVerification}
        options={verificationStatusOption}
      />

      {!disabledSearch && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          flexGrow={1}
          sx={{ width: { xs: 1, md: 'auto' } }}
        >
          <UserSearchAutocomplete value={filters.name} onChange={handleFilterName} />
        </Stack>
      )}
    </Stack>
  );
}
